export enum StatoPreferenza {
    daScegliere = "DA_SCEGLIERE",
    nonScelto = "NON_SCELTO",
    scaduto = "SCADUTO",
    scelto = "SCELTO"
}